import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { compareExcelAlphabetical } from '~/functions/helpers';
import { FundStrategy, useAddFundMutation, useListFundsQuery, useGetAccountQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var _useAddFundMutation = useAddFundMutation(),
      addFund = _useAddFundMutation.mutate,
      onDone = _useAddFundMutation.onDone;
    onDone(function () {
      refetch();
    });
    var _useListFundsQuery = useListFundsQuery({}, {
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first'
      }),
      result = _useListFundsQuery.result,
      loading = _useListFundsQuery.loading,
      refetch = _useListFundsQuery.refetch;
    var funds = computed(function () {
      var _result$value$listFun, _result$value;
      var locale = $i18n.locale || 'en';
      return _toConsumableArray((_result$value$listFun = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listFunds) !== null && _result$value$listFun !== void 0 ? _result$value$listFun : []).sort(function (a, b) {
        var _a$name, _b$name;
        return compareExcelAlphabetical((_a$name = a.name) !== null && _a$name !== void 0 ? _a$name : '', (_b$name = b.name) !== null && _b$name !== void 0 ? _b$name : '', locale);
      });
    });
    var _useGetAccountQuery = useGetAccountQuery(),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value$, _accountResult$value;
      return (_accountResult$value$ = (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount) !== null && _accountResult$value$ !== void 0 ? _accountResult$value$ : {
        id: ''
      };
    });
    var hasSfdrReport = function hasSfdrReport(fund) {
      if ((fund === null || fund === void 0 ? void 0 : fund.fundStrategy) == null || (fund === null || fund === void 0 ? void 0 : fund.fundStrategy) === FundStrategy.Article_6 && (fund === null || fund === void 0 ? void 0 : fund.isReportingKfw) === false && (fund === null || fund === void 0 ? void 0 : fund.isReportingPais) === false) {
        return false;
      }
      return true;
    };
    return {
      __sfc: true,
      $i18n: $i18n,
      addFund: addFund,
      onDone: onDone,
      result: result,
      loading: loading,
      refetch: refetch,
      funds: funds,
      accountResult: accountResult,
      account: account,
      hasSfdrReport: hasSfdrReport
    };
  }
});